<template>
  <el-row class="specimen-control">
    <el-col :span="16">
      <div class="specimen-control-item">
        <span class="text">共 {{ count }} 条</span>
      </div>

      <el-button
        class="specimen-control-item"
        type="primary"
        :loading="creating"
        @click="triggerCreate"
      >
        上传
      </el-button>

      <input
        ref="create"
        style="display:none;"
        type="file"
        accept="image/png,image/jpeg,image/x-png"
        @change="create"
      />
    </el-col>
  </el-row>
</template>

<script>
export default {
  props: {
    count: [Number, String],
    creating: Boolean
  },
  methods: {
    triggerCreate() {
      this.$refs.create.click()
    },
    create(evt) {
      let { files } = evt.target
      if (files && files[0]) {
        this.$emit('create', files[0])
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.specimen-control {
  padding: 8px;
  border-bottom: solid 1px #d9d9d9;
  .el-col {
    display: flex;
    align-items: center;
  }
}
.specimen-control-item {
  display: inline-block;
}
.specimen-control-item:not(:last-child) {
  margin-right: 12px;
}
</style>
